import React from 'react';
import { CtaButton } from './CtaButton';
import { PRICE, mockupImage } from '../data/offer';
export function Hero() {
  return <header className="w-full bg-carbon-900 pb-12 pt-10 sm:pb-16 sm:pt-14 lg:pb-24 lg:pt-20" data-id="element-131" data-mp="ej4pg2ybuli3">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-132" data-mp="9llat1xpw6pm">
        <p className="flex items-center justify-center gap-3 text-center text-[10px] font-bold uppercase tracking-[0.2em] text-mint sm:gap-4 sm:text-xs sm:tracking-[0.28em]" data-id="element-133" data-mp="4lyx6rdz8oga">
          <span className="hidden h-px w-10 bg-mint-deep/70 sm:block" aria-hidden="true" data-id="element-134" data-mp="1274orr9pfk8a" />
          The complete PDF method for running coaches
          <span className="hidden h-px w-10 bg-mint-deep/70 sm:block" aria-hidden="true" data-id="element-135" data-mp="sai16upzuf2k" />
        </p>

        <h1 className="display-tight mx-auto mt-6 max-w-4xl text-center font-display text-[36px] uppercase text-paper sm:mt-8 sm:text-[64px] lg:text-[80px]" data-id="element-136" data-mp="nb6ktmtjhbli">
          Stop searching for drills
          <span className="mt-1 block text-mint" data-id="element-137" data-mp="3825wklpczzj9">on YouTube</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-paper-dim sm:mt-7 sm:text-xl" data-id="element-138" data-mp="3j8sgk46tfprf">
          The “open &amp; coach” PDF system that turns your session planning from{' '}
          <span className="text-mint" data-id="element-139" data-mp="39aur5dd7zmx8">chaotic</span> into{' '}
          <span className="font-semibold text-paper" data-id="element-140" data-mp="39cfotbutzlzb">obvious</span>. 100+ science-based drills, ready
          the second you download them.
        </p>

        <div className="relative mx-auto mt-10 max-w-5xl sm:mt-12" data-id="element-141" data-mp="30gzw4y5tbcvb">
          <span className="absolute -top-3 right-3 z-10 rounded-full bg-mint px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-carbon-900 sm:-top-4 sm:right-8 sm:px-5 sm:py-2 sm:text-xs" data-id="element-142" data-mp="358hmksa7lv21">
            1 pack + 5 bonuses — all PDF
          </span>
          <div className="rounded-2xl border border-carbon-line bg-carbon-800 p-2 sm:p-3" data-id="element-143" data-mp="2vj7wtj2u8oh3">
            <img src={mockupImage} alt="The Running Professional Pack shown on a desktop screen with its five bonus PDF covers on tablets" className="w-full rounded-xl object-cover" loading="eager" data-id="element-144" data-mp="2hjyot6osd0o7" />
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center sm:mt-12" data-id="element-145" data-mp="na09izvsh5ep">
          <CtaButton size="lg" note="Secure checkout — instant PDF download" data-id="element-146" data-mp="id9umfvq0fuv">
            Get the full pack — {PRICE}
          </CtaButton>
          <p className="mt-5 text-sm text-paper-dim" data-id="element-147" data-mp="db2cf8kas3k3">
            <s className="opacity-60" data-id="element-148" data-mp="1b15prg5n5zpj">$552 value</s>{' '}
            <span className="ml-1 text-paper" data-id="element-149" data-mp="1ayjgnc33rc57">today only {PRICE}</span>
          </p>
        </div>
      </div>
    </header>;
}